import { Component, input } from '@angular/core';

// Reusable soft-light aurora backdrop, shared by the sections below the hero.
@Component({
    selector: 'app-landing-glow',
    standalone: true,
    templateUrl: './landing-glow.component.html',
    styleUrl: './landing-glow.component.scss'
})
export class LandingGlow {
    // Picks a distinct blob arrangement (see .scss) so consecutive sections don't look copy-pasted.
    readonly variant = input<number>(1);
}
